import { defineStore } from 'pinia';
import { useUtilsStore } from "@/store";

export const useRegStore = defineStore({
    id: 'reg',
    state: () => ({
        requestId: "",
        username: "",
        password: "",
        passwordConfirm: "",
        fullname: "",
        birthday: "1990-10-30",
        gender: 0,
        secureCode: "",
        serviceId: process.env.VUE_APP_DEFAULT_SERVICE_ID,
        secureDataInfo: "",
        secureTypeID: 0,
        signNextStep: "",
    }),
    actions: {
        async register(step) {
            let raw = {
                "RequestID": this.requestId || "",
                "DeviceDetail": useUtilsStore().getDeviceDetail(),
                "ClientIP": await useUtilsStore().getIPAddress(),
                "AccountName": this.username  || "",
                "Password": this.password  || "",
                "ServiceID": this.serviceId,
                "ConfirmPassword": this.passwordConfirm  || "",
                "SecureCode": this.secureCode || "",
                "SecureTypeID": this.secureTypeID || 0,
                "FullName": this.fullname || "",
                "BirthDay": this.birthday || null,
                "Gender": this.gender || 0,
                "Step": step,
                "Sign": this.signNextStep || ""
            }
            const response = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_SSO_URL}v1.0/AccountRegister`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(raw),
            }).then((res) => {
                return res.json();
            });
            return response;
        },
        async checkAccount() {
            let raw = {
                "RequestID": "",
                "DeviceDetail": useUtilsStore().getDeviceDetail(),
                "ClientIP": await useUtilsStore().getIPAddress(),
                "AccountName": this.username
              }
            const response = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_SSO_URL}v1.0/CheckAccountExist`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(raw),
            }).then((res) => {
                return res.json();
            });
            return response;
        }
    }
});